import { useState, useCallback } from 'react';
import { TweenMax, TimelineMax } from 'gsap';
import css from './tabListC.module.scss';
import SwiperA from './swiperA';
import KitH from './kitH';
import KitI from './kitI';
import KitK from './kitK';
import Home1 from './home1';
import Home2 from './home2';
import Home3 from './home3';
import { useGlobal } from '@/utils/useGlobal';

let timerCDebounce: NodeJS.Timeout;

export default function TabListC({ callBack, tab }: any) {
    const { useEffect, useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const elemStart = '.tabListC';
    const startHNum1 = 200;
    const overHnum1 = 300;

    const [swiperData, setSwiperData] = useState<any>({
        title0: t('presale.product.tab_listC_title0'),
        title1: t('presale.product.tab_listC_title1'),
        title2: t('presale.product.tab_listC_title2'),
        list: [],
    });

    const opacityAnimate = useCallback((pClassName, list, startHNum = startHNum1, overHNum = overHnum1) => {
        const scene = new ScrollMagic.Scene({
            triggerElement: `${elemStart} ${pClassName}`,
            offset: startHNum, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: overHNum, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const timeline = new TimelineMax();
        list?.forEach((item: any) => {
            const tween = TweenMax.fromTo(`${elemStart} ${item.class}`, Number(`${item.duration || 0.2}`), { opacity: 0 }, { opacity: 1 });
            item.position ? timeline.add(tween, item.position) : timeline.add(tween);
        });
        scene.setTween(timeline);
        AniContainer?.addScene(scene);
    }, []);

    // 异步去设置swiper的数据
    useEffect(() => {
        const doSwiperData = () => {
            clearInterval(timerCDebounce);
            timerCDebounce = setTimeout(() => {
                const tabHeadDom = document.querySelector('.product-wrapper .kitC') as HTMLElement;
                const tabHeadDomOffsetTop = tabHeadDom?.offsetTop;
                const windowScrollH = document.documentElement.scrollTop;

                if (windowScrollH > tabHeadDomOffsetTop && swiperData?.list.length === 0) {
                    document.removeEventListener('scroll', doSwiperData);
                    setSwiperData({
                        title0: t('presale.product.tab_listC_title0'),
                        title1: t('presale.product.tab_listC_title1'),
                        title2: t('presale.product.tab_listC_title2'),
                        list: [
                            {
                                i18n: 'listC_1',
                                src: ['/video/mm100/home1.webm', '/video/mm100/home1.mp4'],
                            },
                            // {
                            //     i18n: 'listC_2',
                            //     src: ['/video/mm100/home2.webm', '/video/mm100/home2.mp4'],
                            // },
                            // {
                            //     i18n: 'listC_3',
                            //     src: ['/video/mm100/home3.webm', '/video/mm100/home3.mp4']
                            // }
                        ],
                    });
                }
            }, 100);
        };
        document.addEventListener('scroll', doSwiperData);
        return () => {
            document.removeEventListener('scroll', doSwiperData);
        };
    }, []);

   

    useEffect(() => {
        // swiperA 动画
        const swiperA0 = [{ class: '.swiperA .kit-ms0', duration: 1 }];
        opacityAnimate('.swiperA .kit-ms0', swiperA0);
        const swiperA1 = [{ class: '.swiperA .kit-ms1', duration: 1 }];
        opacityAnimate('.swiperA .kit-ms1', swiperA1);
        const swiperA2 = [{ class: '.swiperA .kit-ms2', duration: 1 }];
        opacityAnimate('.swiperA .kit-ms1', swiperA2);

        // KitH 动画
        const kitHList1 = [{ class: '.kitH .kit-ms1' }];
        opacityAnimate('.kitH .kit-l', kitHList1);
        const kitHList2 = [{ class: '.kitH .kit-ms2' }];
        opacityAnimate('.kitH .kit-ms2', kitHList2);
        const kitHList3 = [{ class: '.kitH .kit-ms3' }];
        opacityAnimate('.kitH .kit-ms3', kitHList3);

        // KitK 动画
        const kitKList1 = [{ class: '.kitK .kit-ms-box-in' }];
        opacityAnimate('.kitK .kit-ms-box', kitKList1);

        // KitI 动画
        const kitIList1 = [{ class: '.kitI .kit-ms1' }, { class: '.kitI .kit-ms2' }];
        opacityAnimate('.kitI .kit-inter1', kitIList1);
        const kitIList2 = [{ class: '.kitI .kit-inter2' }];
        opacityAnimate('.kitI .kit-inter2', kitIList2);
    }, []);

    return (
        <div className={`${css.tabListC} tabListC`}>
            <Home1 />
            <SwiperA data={swiperData} tab={tab} tabHide />
            <Home2 />
            <div className="home3_img">
                <Home3
                    data={{
                        text1: t('presale.product.home3_1_text1'),
                        text2: t('presale.product.home3_1_text2'),
                        text3: t('presale.product.home3_1_text3'),
                        isVideo: false,
                        cls: '.home3_img',
                    }}
                />
            </div>
            <div className="home3_video">
                <Home3
                    data={{
                        text1: t('presale.product.home3_2_text1'),
                        text2: t('presale.product.home3_2_text2'),
                        text3: t('presale.product.home3_2_text3'),
                        cls: '.home3_video',
                    }}
                />
            </div>
            <KitH type="home" />
            <KitK />
            <KitI type="home" />
        </div>
    );
}
